import React from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/itmonkeys-video.mp4';
import SecurityImg from '../../../assets/images/itmonkeys-datacenter.png';
import './IntroSectionHome.css';
import './NavigationLinks.css';
import { IntroSectionData } from '../../../types/IntroSectionData';

interface IntroSectionHome2Props {
  academyData?: IntroSectionData;
}

const IntroSectionHome2: React.FC<IntroSectionHome2Props> = ({ academyData }) => {
  const { t } = useTranslation();

  const handleNavigateToSlide = (slideIndex: number) => {
    const event = new CustomEvent('navigateToSlide', {
      detail: { slideIndex }
    });
    window.dispatchEvent(event);

    const sliderElement = document.querySelector('.home-slider-container');
    if (sliderElement) {
      sliderElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="intro-section-home intro-section-home-2">
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('home.cloud.title')}</h2>
            <h3 style={{maxWidth: "520px"}}>
              {t('home.cloud.description')}
            </h3>
            <div className="intro-navigation-link">
            </div>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={ItmonkeysVideo} type="video/mp4" />
              {t('home.video.notSupported', 'Votre navigateur ne supporte pas la balise vidéo.')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('home.security.title')}</h2>
            <h3>{t('home.security.description')}</h3>
            <div className="intro-navigation-link">
            </div>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={SecurityImg}
              alt={t('home.security.imageAlt')}
            />
          </div>
        </div>
        <div className="intro-bottom-home">
          <div className="intro-row-1">
            {academyData && (
              <>
                <div className="intro-text-1 adjust-landing adjust-text-academy">
                  <h2>{t('home.academy.title', { defaultValue: academyData.sectionTitle })}</h2>
                  <h3>
                    {academyData.tabsData && academyData.tabsData[0] && academyData.tabsData[0].text
                      ? t('home.academy.content', { defaultValue: academyData.tabsData[0].text })
                      : t('home.academy.defaultContent', { defaultValue: "L'excellence se construit aussi par la formation de vos équipes. Investir dans leurs compétences, c'est investir dans l'avenir de votre entreprise." })}
                  </h3>
                  <div className="intro-navigation-link">
                  </div>
                </div>
                <div className="intro-image">
                  <img
                    src={academyData.fixedImageSrc}
                    loading="lazy"
                    className="intro-media"
                    alt={t('home.academy.imageAlt', { defaultValue: academyData.fixedImageAlt })}
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionHome2;